export default __webpack_public_path__ + "static/media/system-filled.8a95ea99.svg";